export default {
  address: [
    'user-input',
    'map',
    'underground',
  ],
  'about-object': [
    {
      name: 'common/cadastral-number',
      hideInSimpleForm: true,
    },
    'housing-type',
    'rooms-count',
    'room-type',
    'urban-total-area',
    'layout-photo',
    'floor',
    {
      name: 'all-rooms-area',
      hideInSimpleForm: true,
    },
    'living-area',
    'kitchen-area',
    'visual-divider', {
      name: 'loggias-count',
      hideInSimpleForm: true,
    }, {
      name: 'balconies-count',
      hideInSimpleForm: true,
    }, {
      name: 'window-view-type',
      hideInSimpleForm: true,
    }, {
      name: 'visual-divider',
      hideInSimpleForm: true,
    }, {
      name: 'separate-wcs-count',
      hideInSimpleForm: true,
    }, {
      name: 'combined-wcs-count',
      hideInSimpleForm: true,
    }, {
      name: 'visual-divider',
      hideInSimpleForm: true,
    }, {
      name: 'repair-type',
    }, {
      name: 'in-flat-rent',
      hideInSimpleForm: true,
    }, {
      name: 'visual-divider',
      onlyShowInSimpleForm: true,
    }, {
      name: 'pets-allowed',
      onlyShowInSimpleForm: true,
    }, {
      name: 'children-allowed',
      onlyShowInSimpleForm: true,
    }, {
      name: 'visual-divider',
      onlyShowInSimpleForm: true,
    }, {
      name: 'additional-simple-form',
      onlyShowInSimpleForm: true,
    },
  ],
  'about-building': [
    {
      name: 'name-and-year',
      simpleForm: {
        order: 5,
      },
    }, {
      name: 'material-type-and-series',
      simpleForm: {
        order: 1,
      },
    }, {
      name: 'ceiling-height',
      simpleForm: {
        order: 6,
      },
    }, {
      name: 'passenger-lifts',
      simpleForm: {
        order: 2,
      },
    }, {
      name: 'cargo-lifts',
      simpleForm: {
        order: 3,
      },
    }, {
      name: 'visual-divider',
      onlyShowInSimpleForm: true,
      simpleForm: {
        order: 4,
      },
    }, {
      name: 'has-ramp',
    }, {
      name: 'in-house',
    }, {
      name: 'parking',
    },
  ],
  'price-and-deal-terms': [
    {
      name: 'price-rent',
      simpleForm: {
        order: 1,
      },
    }, {
      name: 'utilities-terms',
      simpleForm: {
        order: 2,
      },
    }, {
      name: 'visual-divider',
      hideInSimpleForm: true,
    }, {
      name: 'bargain',
      hideInSimpleForm: true,
    },
    'prepay-type',
    'self-employed',
    {
      name: 'deposit',
      simpleForm: {
        order: 3,
      },
    },
    {
      name: 'fee',
      hideInSimpleForm: true,
    },
  ],
};
